import { createFileRoute, redirect } from '@tanstack/react-router';

/** Retired tab — renewal now lives in the single Recurring jobs page (moment 3). */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/renewal')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/contracts' });
  },
  component: () => null,
});
